/**
 * Unluckies PDP — ub-pdp.js
 * Size/pack selection, waist recommender, mix-size steppers, /cart/add.js ATC, sticky bar.
 */
(function () {
  'use strict';

  var PACKS = [
    { id: 'single', name: 'Just one', pairs: 1, total: 89.0 },
    { id: 'three', name: 'The three', pairs: 3, total: 214.0 },
    { id: 'week', name: 'The week', pairs: 7, total: 436.0 },
    { id: 'drawer', name: 'The drawer', pairs: 9, total: 521.0 },
    { id: 'twelve', name: '12 pairs', pairs: 12, total: 641.0 }
  ];

  var WAIST_HINTS = {
    M: '30–32"',
    L: '33–35"',
    XL: '36–38"',
    XXL: '39–42"'
  };

  function money(n) {
    return 'AED ' + Number(n).toFixed(2);
  }


  var CART_SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';

  function bundleOwnsSticky() {
    // Whenever Build Your Pack is on the page, it owns sticky title/sub for ALL tiers
    // (including Just one) so ub-pdp render() cannot overwrite The Three / Week / Drawer.
    return !!document.querySelector('[data-ubp]');
  }

  function normalizeAddResponse(data) {
    var response = data || {};
    if (!response.key && response.items && response.items.length) {
      var first = response.items[0] || {};
      response = Object.assign({}, response, {
        key: first.key,
        variant_id: first.variant_id
      });
    }
    return response;
  }

  function applyCartCount(n) {
    if (typeof n !== 'number' || isNaN(n) || n < 0) n = 0;
    try {
      if (window.theme) window.theme.cartItemCount = n;
      if (window.Alpine && Alpine.store('cart_count')) Alpine.store('cart_count').count = n;
    } catch (eA) {}
  }

  /** Always set cart_count from /cart.js — never leave count undefined (drawer "UNDEFINED ITEMS"). */
  function syncCartCountFromCartJs() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
        applyCartCount(n);
        return cart;
      })
      .catch(function () {
        applyCartCount(0);
        return null;
      });
  }

  function syncCartCountFromSections(response) {
    try {
      var html = response && response.sections && response.sections['cart-item-count'];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var text = ((doc.body && doc.body.textContent) || '').trim();
        var n = parseInt(text, 10);
        if (!isNaN(n)) applyCartCount(n);
      }
    } catch (e) {}
    // Always follow with cart.js so Alpine never keeps undefined
    return syncCartCountFromCartJs();
  }

  /** Pack Add intentional replace: clear cart so /cart/add.js cannot merge into existing lines. */
  function clearCartForPackReplace() {
    // Pack is intentional replace for clean drawer (exact pack qty/total).
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
    }).then(function (r) {
      return r.json().catch(function () { return {}; });
    }).catch(function () { return {}; });
  }

  function ensureCartSections(data) {
    if (data && data.sections && data.sections['cart-items'] && data.sections['cart-item-count']) {
      return Promise.resolve(normalizeAddResponse(data));
    }
    var url = (window.location.pathname || '/') + '?sections=' + CART_SECTIONS;
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        return normalizeAddResponse(Object.assign({}, data || {}, { sections: sections }));
      })
      .catch(function () { return normalizeAddResponse(data || {}); });
  }

  /** Emit Shapes after-add + force drawer open + remorph (covers data-island idle race). */
  function fireCartEvent(name, detail) {
    var ev = new CustomEvent(name, { bubbles: true, detail: detail });
    try { document.body.dispatchEvent(ev); } catch (e0) {}
    try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail })); } catch (e1) {}
    try { window.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail })); } catch (e2) {}
  }

  function openCartDrawerHard() {
    try {
      if (window.Alpine && Alpine.store('modals')) Alpine.store('modals').open('cart');
    } catch (eOpen) {}
    try {
      var btn = document.getElementById('CartButton');
      if (btn) btn.click();
    } catch (eClick) {}
    try {
      document.dispatchEvent(new CustomEvent('theme:open:cart-drawer'));
    } catch (eTheme) {}
  }

  function shapesAfterAdd(data, sourceId) {
    return ensureCartSections(data).then(function (response) {
      function remorph() {
        fireCartEvent('shapes:cart:update', { response: response });
        try {
          var html = response.sections && response.sections['cart-items'];
          var root = document.querySelector('[data-cart-items]');
          if (html && root && window.Alpine && typeof Alpine.morph === 'function') {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var src = doc.querySelector('[data-cart-items]');
            if (src) Alpine.morph(root, src.outerHTML);
          }
        } catch (eMorph) {}
      }

      // 1) Set count from cart.js BEFORE open (never undefined)
      // 2) afteradditem remorph BEFORE/with open
      // 3) open drawer
      // 4) re-sync count from cart.js after open
      return syncCartCountFromCartJs().then(function () {
        syncCartCountFromSections(response);
        fireCartEvent('shapes:cart:afteradditem', {
          response: response,
          sourceId: sourceId || 'ub-pdp'
        });
        remorph();
        openCartDrawerHard();
        return syncCartCountFromCartJs().then(function () {
          remorph();
          setTimeout(function () { remorph(); syncCartCountFromCartJs(); }, 100);
          setTimeout(function () { remorph(); syncCartCountFromCartJs(); }, 300);
          setTimeout(function () { openCartDrawerHard(); remorph(); syncCartCountFromCartJs(); }, 800);
          setTimeout(function () { openCartDrawerHard(); remorph(); syncCartCountFromCartJs(); }, 1500);
          return response;
        });
      });
    });
  }


  function etaLabel(locale) {
    var d = new Date(Date.now() + 2 * 86400000);
    return d.toLocaleDateString(locale || 'en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function recommend(waist) {
    var w = parseFloat(waist);
    if (!w || w < 26 || w > 48) return null;
    if (w <= 32) return { size: 'M', ok: true };
    if (w <= 35) return { size: 'L', ok: true };
    if (w <= 38) return { size: 'XL', ok: true };
    if (w <= 42) return { size: 'XXL', ok: false };
    return { size: null, ok: false };
  }

  function init(root) {
    if (!root || root.dataset.ubReady) return;
    root.dataset.ubReady = '1';

    var cfg = {};
    try {
      cfg = JSON.parse(root.getAttribute('data-ub-config') || '{}');
    } catch (e) {
      cfg = {};
    }

    var isNine = !!cfg.isNine;
    var isArabic = String(cfg.locale || document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
    function packName(p) {
      if (!isArabic) return p.name;
      return { single: 'قطعة واحدة', three: 'الثلاثة', week: 'باقة الأسبوع', drawer: 'باقة الدرج', twelve: '12 قطعة' }[p.id] || p.name;
    }
    var variantMap = cfg.variants || {};
    // Accept either flat ids or {id:...} objects
    Object.keys(variantMap).forEach(function (k) {
      var v = variantMap[k];
      if (v && typeof v === 'object' && v.id != null) variantMap[k] = v.id;
    });
    var unitPrice = Number(cfg.unitPrice) || 89;

    var state = {
      size: null,
      pack: 'single',
      counts: {},
      qty: 1,
      packsOpen: true,
      scrolled: false
    };

    Object.keys(variantMap).forEach(function (k) {
      state.counts[k] = 0;
    });

    var els = {
      sizeBtns: root.querySelectorAll('[data-ub-size]'),
      stickyChips: root.querySelectorAll('[data-ub-sticky-size]'),
      packBtns: root.querySelectorAll('[data-ub-pack]'),
      packsBody: root.querySelector('[data-ub-packs-body]'),
      packsToggle: root.querySelector('[data-ub-packs-toggle]'),
      packsMark: root.querySelector('[data-ub-packs-mark]'),
      mix: root.querySelector('[data-ub-mix]'),
      qtyRow: root.querySelector('[data-ub-qty-row]'),
      qtyVal: root.querySelector('[data-ub-qty-val]'),
      pickedLabel: root.querySelector('[data-ub-picked]'),
      atc: root.querySelectorAll('[data-ub-atc]'),
      variantInput: root.querySelector('[data-ub-variant-input]'),
      hint: root.querySelector('[data-ub-hint]'),
      waist: root.querySelector('[data-ub-waist]'),
      waistRec: root.querySelector('[data-ub-waist-rec]'),
      sticky: root.querySelector('[data-ub-sticky]'),
      stickyTitle: root.querySelector('[data-ub-sticky-title]'),
      stickySub: root.querySelector('[data-ub-sticky-sub]'),
      stickySizes: root.querySelector('[data-ub-sticky-sizes]'),
      stickyAtc: root.querySelector('[data-ub-sticky-atc], [data-ub-sticky] [data-ub-atc]'),
      eta: root.querySelector('[data-ub-eta]'),
      freeShip: root.querySelector('[data-ub-free-ship]'),
      freeShipMark: root.querySelector('[data-ub-free-ship-mark]'),
      toast: root.querySelector('[data-ub-toast]'),
      thumbs: root.querySelectorAll('[data-ub-thumb]'),
      mainImg: root.querySelector('[data-ub-main-img]'),
      faqItems: root.querySelectorAll('[data-ub-faq-item]')
    };

    if (els.eta) els.eta.textContent = etaLabel(isArabic ? 'ar-AE' : 'en-GB');

    function activePack() {
      return PACKS.find(function (p) { return p.id === state.pack; }) || PACKS[0];
    }

    function picked() {
      var t = 0;
      Object.keys(state.counts).forEach(function (k) { t += state.counts[k] || 0; });
      return t;
    }

    function orderTotal() {
      var p = activePack();
      return p.pairs > 1 ? p.total : unitPrice * state.qty;
    }

    function isReady() {
      var p = activePack();
      if (p.pairs > 1) return picked() === p.pairs;
      return !!state.size && !!variantMap[state.size];
    }

    function hintText() {
      var p = activePack();
      if (p.pairs > 1) {
        var remain = Math.max(0, p.pairs - picked());
        if (remain > 0) return isArabic ? 'اختر ' + remain + ' ' + (remain === 1 ? 'قطعة إضافية' : 'قطع إضافية') : 'Pick ' + remain + ' more ' + (remain === 1 ? 'pair' : 'pairs');
        return isArabic ? '14 يوماً لتقرر · احتفظ بالقطعة التي فتحتها' : '14 days to decide · keep the pair you opened';
      }
      if (!state.size) return isArabic ? 'اختر مقاساً' : 'Choose a size';
      return isArabic ? '14 يوماً لتقرر · احتفظ بالقطعة التي فتحتها' : '14 days to decide · keep the pair you opened';
    }

    function updateFreeShip() {
      var amt = orderTotal();
      if (!els.freeShip) return;
      if (amt >= 150) {
        els.freeShip.textContent = isArabic ? 'حصل هذا الطلب على توصيل مجاني داخل الإمارات.' : 'Free UAE delivery unlocked on this order.';
        if (els.freeShipMark) {
          els.freeShipMark.classList.add('is-ok');
        }
      } else {
        els.freeShip.textContent = isArabic
          ? 'أضف ' + (150 - amt).toFixed(0) + ' درهماً للحصول على توصيل مجاني داخل الإمارات.'
          : 'AED ' + (150 - amt).toFixed(0) + ' more for free UAE delivery — a second pair covers it.';
        if (els.freeShipMark) els.freeShipMark.classList.remove('is-ok');
      }
    }

    function renderSteppers() {
      if (!els.mix) return;
      var rows = els.mix.querySelectorAll('[data-ub-step-size]');
      var p = activePack();
      var tot = picked();
      rows.forEach(function (row) {
        var size = row.getAttribute('data-ub-step-size');
        var val = row.querySelector('[data-ub-step-val]');
        var inc = row.querySelector('[data-ub-step-inc]');
        if (val) val.textContent = String(state.counts[size] || 0);
        if (inc) inc.disabled = tot >= p.pairs;
      });
      if (els.pickedLabel) {
        els.pickedLabel.textContent = isArabic ? 'تم اختيار ' + tot + ' من ' + p.pairs : tot + ' / ' + p.pairs + ' chosen';
      }
    }

    function render() {
      var p = activePack();
      var isPack = p.pairs > 1;
      var ready = isReady();

      els.sizeBtns.forEach(function (btn) {
        var s = btn.getAttribute('data-ub-size');
        btn.classList.toggle('is-selected', state.size === s);
      });
      els.stickyChips.forEach(function (btn) {
        var s = btn.getAttribute('data-ub-sticky-size');
        btn.classList.toggle('is-selected', state.size === s);
      });

      els.packBtns.forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.getAttribute('data-ub-pack') === state.pack);
      });

      if (els.packsBody) {
        els.packsBody.hidden = !(state.packsOpen || isPack);
      }
      if (els.packsMark) {
        els.packsMark.textContent = state.packsOpen || isPack ? '−' : '+';
      }

      if (els.mix) els.mix.hidden = !isPack;
      if (els.qtyRow) els.qtyRow.hidden = isPack;
      if (els.qtyVal) els.qtyVal.textContent = String(state.qty);

      renderSteppers();

      var label = isArabic ? (isPack ? 'أضف الباقة إلى السلة' : 'أضف إلى السلة') : (isPack ? 'Add the pack' : 'Add to cart');
      els.atc.forEach(function (btn) {
        btn.disabled = !ready;
        btn.textContent = label;
      });
      if (els.stickyAtc) {
        els.stickyAtc.disabled = !ready;
        els.stickyAtc.textContent = label;
      }
      if (els.hint) els.hint.textContent = hintText();

      // Bundle builder owns sticky title/sub when THE THREE / WEEK / DRAWER selected
      if (!bundleOwnsSticky()) {
        if (els.stickyTitle) {
          els.stickyTitle.textContent = isPack
            ? packName(p) + ' — ' + (isArabic ? p.total.toFixed(2) + ' درهماً' : money(p.total))
            : (isArabic ? 'قطعة واحدة — ' + (unitPrice * state.qty).toFixed(2) + ' درهماً' : 'One pair — ' + money(unitPrice * state.qty));
        }
        if (els.stickySub) {
          els.stickySub.textContent = isPack
            ? (isArabic ? p.pairs + ' قطع · ' + (p.total / p.pairs).toFixed(0) + ' درهماً للقطعة' : p.pairs + ' pairs · AED ' + (p.total / p.pairs).toFixed(0) + ' a pair')
            : state.size
              ? (isArabic ? 'المقاس ' + state.size : 'Size ' + state.size)
              : (isArabic ? 'اختر مقاساً' : 'Choose a size');
        }
        if (els.stickySizes) {
          els.stickySizes.classList.toggle('is-show', !isPack && !state.size);
        }
      } else if (els.stickySizes) {
        els.stickySizes.classList.remove('is-show');
      }

      updateFreeShip();
    }

    function selectSize(size) {
      if (!variantMap[size]) return;
      state.size = size;
      els.sizeBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-ub-size') === size);
      });
      els.stickyChips.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-ub-sticky-size') === size);
      });
      if (els.variantInput) els.variantInput.value = String(variantMap[size]);
      render();
    }

    function selectPack(id) {
      state.pack = id;
      Object.keys(state.counts).forEach(function (k) {
        state.counts[k] = 0;
      });
      render();
    }

    function buildCartItems() {
      var p = activePack();
      var items = [];
      if (p.pairs > 1) {
        Object.keys(state.counts).forEach(function (size) {
          var qty = state.counts[size] || 0;
          if (qty > 0 && variantMap[size]) {
            items.push({ id: variantMap[size], quantity: qty });
          }
        });
      } else if (state.size && variantMap[state.size]) {
        items.push({ id: variantMap[state.size], quantity: state.qty });
      }
      return items;
    }

    function showToast(msg) {
      if (!els.toast) return;
      els.toast.textContent = msg;
      els.toast.classList.add('is-show');
      clearTimeout(showToast._t);
      showToast._t = setTimeout(function () {
        els.toast.classList.remove('is-show');
      }, 2800);
    }

    function addToCart(e) {
      if (e && e.preventDefault) e.preventDefault();
      if (!isReady()) return;
      var items = buildCartItems();
      if (!items.length) {
        showToast(isArabic ? 'لا تتوفر خيارات مطابقة للمقاس.' : 'No variants available — check size mapping.');
        return;
      }

      els.atc.forEach(function (b) {
        b.disabled = true;
        b.textContent = isArabic ? 'جارٍ الإضافة…' : 'Adding…';
      });
      if (els.stickyAtc) {
        els.stickyAtc.disabled = true;
        els.stickyAtc.textContent = isArabic ? 'جارٍ الإضافة…' : 'Adding…';
      }

      var pack = activePack();
      // Pack (qty>=3): clear-then-add so /cart/add.js cannot merge into existing lines
      // (e.g. cart already has 1 → adding THE THREE would become 4). Just one: normal merge OK.
      var isPackReplace = !!(pack && pack.pairs >= 3);
      var addPromise = isPackReplace
        ? clearCartForPackReplace().then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: items,
                sections: CART_SECTIONS,
                sections_url: window.location.pathname
              })
            });
          })
        : fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: items,
              sections: CART_SECTIONS,
              sections_url: window.location.pathname
            })
          });

      addPromise
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function (data) {
          showToast(isArabic ? 'تمت الإضافة — يمكنك عرض السلة الآن' : 'Added — view cart anytime');
          document.dispatchEvent(new CustomEvent('ub:cart:added', { detail: { items: items } }));
          var sid = (buyForm && buyForm.id) || 'ub-pdp';
          return shapesAfterAdd(data, sid).then(function () {
            try {
              syncCartCountFromCartJs().then(function (cart) {
                if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
              });
            } catch (e) {}
            render();
          });
        })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || (isArabic ? 'تعذرت الإضافة إلى السلة' : 'Could not add to cart');
          showToast(msg);
          render();
        });
    }

    // Events
    els.sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectSize(btn.getAttribute('data-ub-size'));
      });
    });
    els.stickyChips.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectSize(btn.getAttribute('data-ub-sticky-size'));
      });
    });
    els.packBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectPack(btn.getAttribute('data-ub-pack'));
      });
    });

    if (els.packsToggle) {
      els.packsToggle.addEventListener('click', function () {
        state.packsOpen = !state.packsOpen;
        render();
      });
    }

    root.querySelectorAll('[data-ub-step-dec]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var size = btn.getAttribute('data-ub-step-dec');
        state.counts[size] = Math.max(0, (state.counts[size] || 0) - 1);
        render();
      });
    });
    root.querySelectorAll('[data-ub-step-inc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var size = btn.getAttribute('data-ub-step-inc');
        var p = activePack();
        if (picked() >= p.pairs) return;
        state.counts[size] = (state.counts[size] || 0) + 1;
        render();
      });
    });

    var decQty = root.querySelector('[data-ub-qty-dec]');
    var incQty = root.querySelector('[data-ub-qty-inc]');
    if (decQty) {
      decQty.addEventListener('click', function () {
        state.qty = Math.max(1, state.qty - 1);
        render();
      });
    }
    if (incQty) {
      incQty.addEventListener('click', function () {
        state.qty = Math.min(9, state.qty + 1);
        render();
      });
    }

    els.atc.forEach(function (btn) {
      btn.addEventListener('click', addToCart);
    });
    // sticky ATC already has data-ub-atc — only bind once if not in NodeList
    if (els.stickyAtc) {
      var stickyAlready = false;
      els.atc.forEach(function (b) { if (b === els.stickyAtc) stickyAlready = true; });
      if (!stickyAlready) els.stickyAtc.addEventListener('click', addToCart);
    }
    var buyForm = root.querySelector('form.ub-pdp__buy-form');
    if (buyForm) buyForm.addEventListener('submit', addToCart);

    if (els.waist) {
      els.waist.addEventListener('input', function () {
        var rec = recommend(els.waist.value);
        if (!els.waistRec) return;
        els.waistRec.classList.remove('is-ok', 'is-warn');
        if (!rec) {
          els.waistRec.textContent = isArabic ? 'سنختار مقاسك' : 'We’ll pick your size';
          return;
        }
        if (rec.ok) {
          els.waistRec.textContent = isArabic ? 'مقاسك ' + rec.size + ' — تم اختياره' : 'Wear ' + rec.size + ' — selected';
          els.waistRec.classList.add('is-ok');
          if (variantMap[rec.size]) selectSize(rec.size);
        } else if (rec.size === 'XXL') {
          els.waistRec.textContent = isNine
            ? (isArabic ? 'مقاسك XXL — تم اختياره' : 'Wear XXL — selected')
            : (isArabic ? 'تحتاج إلى قصة 9 إنش المنفصلة بمقاس XXL' : 'You need the separate 9" XXL cut');
          els.waistRec.classList.add('is-warn');
          if (isNine && variantMap.XXL) selectSize('XXL');
        } else {
          els.waistRec.textContent = isArabic ? 'خارج نطاق مقاساتنا' : 'Outside our range';
          els.waistRec.classList.add('is-warn');
        }
      });
    }

    els.thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-ub-thumb');
        var alt = thumb.getAttribute('data-ub-alt') || '';
        if (els.mainImg && src) {
          els.mainImg.src = src;
          els.mainImg.alt = alt;
        }
        els.thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    els.faqItems.forEach(function (item) {
      var mark = item.querySelector('.ub-pdp__faq-mark');
      function syncMark() {
        if (mark) mark.textContent = item.open ? '−' : '+';
      }
      item.addEventListener('toggle', syncMark);
      syncMark();
    });

    function onScroll() {
      var s = window.scrollY > 120;
      if (s !== state.scrolled) {
        state.scrolled = s;
        if (els.sticky) els.sticky.classList.toggle('is-visible', s);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    document.body.classList.add('ub-pdp-active');

    function hideTenPercentTab() {
      var nodes = document.querySelectorAll('body a, body button, body div, body span');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.closest && el.closest('.ub-pdp')) continue;
        if (el.childElementCount > 2) continue;
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t) continue;
        if (/^10%\s*First/i.test(t) || t === '10% First' || /^10%\s*First Time/i.test(t)) {
          var hide = el.closest('[class*="teaser"], [class*="kl-"], [style*="position"]') || el;
          hide.style.setProperty('display', 'none', 'important');
          hide.setAttribute('data-ub-hidden-offer-tab', '1');
        }
      }
    }
    hideTenPercentTab();
    setTimeout(hideTenPercentTab, 800);
    setTimeout(hideTenPercentTab, 2500);

    render();
  }


  /* Flatten Judge.me masonry into one horizontal scroll row */
  function flattenJudgeMeRow() {
    var roots = document.querySelectorAll('#judgeme_product_reviews, .jdgm-rev-widg, section.jdgm-masonry-grid');
    if (!roots.length) return;
    var pageIsArabic = String(document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
    if (pageIsArabic) {
      document.querySelectorAll('#judgeme_product_reviews h2, #judgeme_product_reviews button, #judgeme_product_reviews [class*="title"], #judgeme_product_reviews [class*="count"]').forEach(function (el) {
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (text === 'Customer Reviews') el.textContent = 'تقييمات العملاء';
        else if (text === 'Write a review') el.textContent = 'اكتب مراجعة';
        else if (/^Product reviews\s*\(0\)$/.test(text)) el.textContent = 'مراجعات المنتج (0)';
      });
    }
    var containers = document.querySelectorAll(
      '#jdgm-masonry-grid-id, .jdgm-masonry-grid__container, #judgeme_product_reviews .jdgm-rev-widg__reviews'
    );
    containers.forEach(function (c) {
      c.style.setProperty('display', 'flex', 'important');
      c.style.setProperty('flex-direction', 'row', 'important');
      c.style.setProperty('flex-wrap', 'nowrap', 'important');
      c.style.setProperty('overflow-x', 'auto', 'important');
      c.style.setProperty('overflow-y', 'hidden', 'important');
      c.style.setProperty('height', 'auto', 'important');
      c.style.setProperty('max-height', 'none', 'important');
      c.style.setProperty('gap', '12px', 'important');
      c.style.setProperty('position', 'relative', 'important');
      c.style.setProperty('column-count', 'auto', 'important');
    });
    document.querySelectorAll('.jdgm-masonry-grid__masonry-item').forEach(function (item) {
      item.style.setProperty('position', 'relative', 'important');
      item.style.setProperty('left', 'auto', 'important');
      item.style.setProperty('top', 'auto', 'important');
      item.style.setProperty('right', 'auto', 'important');
      item.style.setProperty('bottom', 'auto', 'important');
      item.style.setProperty('transform', 'none', 'important');
      item.style.setProperty('float', 'none', 'important');
      item.style.setProperty('flex', '0 0 min(300px, 78vw)', 'important');
      item.style.setProperty('width', 'min(300px, 78vw)', 'important');
      item.style.setProperty('max-width', 'min(300px, 78vw)', 'important');
      item.style.setProperty('min-width', 'min(300px, 78vw)', 'important');
      item.style.setProperty('height', 'auto', 'important');
      item.style.setProperty('margin', '0', 'important');
    });
  }

  function watchJudgeMeRow() {
    flattenJudgeMeRow();
    var t = 0;
    var iv = setInterval(function () {
      flattenJudgeMeRow();
      t += 1;
      if (t > 20) clearInterval(iv);
    }, 500);
    var target = document.getElementById('judgeme_product_reviews') || document.body;
    if (window.MutationObserver && target) {
      var mo = new MutationObserver(function () { flattenJudgeMeRow(); });
      mo.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
      setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 15000);
    }
  }

  function boot() {
    document.querySelectorAll('[data-ub-pdp], [data-ub-root]').forEach(init);
    watchJudgeMeRow();
    setTimeout(watchJudgeMeRow, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
